export const CSS_CLASS = {
  focusedEmptyParagraph: 'focused-empty-paragraph',
  scoreHoverableParent: 'score-hoverable-parent',
  notranslate: 'notranslate',
};
